import { render, staticRenderFns } from "./subsidiaryFeedback.vue?vue&type=template&id=24da0b6b&scoped=true&"
import script from "./subsidiaryFeedback.vue?vue&type=script&lang=js&"
export * from "./subsidiaryFeedback.vue?vue&type=script&lang=js&"
import style0 from "./subsidiaryFeedback.vue?vue&type=style&index=0&id=24da0b6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da0b6b",
  null
  
)

component.options.__file = "subsidiaryFeedback.vue"
export default component.exports